import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import app from "./app.module";
import { account } from "./account.module";
import { menus } from "./menus.module";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: "dld-pangchang",
      paths: ["account"],
      // storage: window.sessionStorage
      // storage: {
      //   getItem: key => ls.get(key),
      //   setItem: (key, value) => ls.set(key, value),
      //   removeItem: key => ls.remove(key)
      // }
    }),
  ],
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    account,
    app,
    menus
  }
});
